<template>
    <div>
        <div v-if="days.length === 0">
            Loading...
        </div>
        <table v-if="days.length > 0" class="table table-striped table-bordered">
            <thead>
                <tr>
                    <td style="width:220px;">Id</td>
                    <td style="width:220px;">Quantity</td>
                    <td style="width:220px;">Price</td>
                    <td style="width:220px;">Total</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(day,index) in days" :key="day.id">
                    <td><input type="text" v-model="day.name" v-on:change="getStock(index, day)"  /></td>
                    <td><input type="text" v-model="day.quantity" /></td>
                    <td>{{day.price}}</td>
                    <td>{{day.price*day.quantity | currency}}</td>
                    <td></td>
                </tr>
            </tbody>
        </table>

    </div>
</template>
<script>
	import portfolio from '@/Services/Portfolio';

    export default {
        data: function () {
            return {
                days: [],
            };
        },
        methods: {
            updateQuantity(item) {
                this.$set(item, 'total', item.price * item.quantity);
            },
            async getStock(index, item) {
                const { data } = await portfolio.getStock(item.name);
                console.log(index, data);
                //this.days[index] = data;
                this.$set(item, 'price', data.price);

            },
            async getCollections() {
                const { data } = await portfolio.getCollections();
                this.days = data;
            }
        },
        async mounted() {
            await this.getCollections();
        }
    }
</script>